import { Col, DatePicker, Row, Select, Typography } from "antd";
import dayjs from "dayjs";
import { useSelector } from "react-redux";

const { RangePicker } = DatePicker;
const { Text } = Typography

export const FirstStep = ({
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    days,
    setDays,
    players,
    setPlayers,
    playerLabels,
    setPlayerLabels
}: IFirstStep) => {
    const {
        positions,
        playerGroups: groups,
        allPlayers,
    } = useSelector(({ team }) => team);

    const handleDateRangeChange = (datesMoments: any, dateStrings: any) => {
        setStartDate(datesMoments?.[0])
        setEndDate(datesMoments?.[1])
    }

    const convertStringToMoment = (dateString: string) => {
        if (!dateString) {
            return null;
        }
        return dayjs(dateString);
    }
    
    return (
        <Col style={{ rowGap: '10px', display: 'flex', flexDirection: 'column' }}>
            <Row style={{ alignItems: 'center', columnGap: '10px' }}>
                <Text>Date Range</Text>
                <RangePicker
                    onChange={handleDateRangeChange}
                    value={(!startDate && !endDate) ? null : [convertStringToMoment(startDate), convertStringToMoment(endDate)]}
                    style={{ width: 250, borderRadius: '5px' }}
                />
                <Text type="secondary">(Max 2 years)</Text>
            </Row>

            <Col style={{ display: 'flex', flexDirection: 'column' }}>
                <Text>Players</Text>

                <Select
                    mode="multiple"
                    labelInValue
                    showSearch
                    filterOption={(input, option: any) => {
                        if (option?.label) {
                            return option.label.toLowerCase().includes(input.toLowerCase());
                        }
                        return false;
                    }}
                    onChange={(data: any) => {
                        setPlayerLabels(data.map((e: any) => e.label))
                        setPlayers(data.map((e: any) => e.value))
                    }}
                    value={players.map((value, index) => ({
                        label: playerLabels[index] || value,
                        value: value
                    }))}
                    placeholder="Players, Positions, Groups"
                    options={[
                        {
                            label: 'Team',
                            options: [
                                { label: 'Full Team', value: 'full-team' }
                            ]
                        },
                        {
                            label: 'Players',
                            options: allPlayers.map((player: any) => {
                                return { label: `${player.first_name} ${player.last_name}`, value: `player-${player.player_id}` }
                            })
                        },
                        {
                            label: 'Positions',
                            options: positions.map((position: any) => {
                                return { label: position, value: `pos-${position}` }
                            })
                        },
                        {
                            label: 'Groups',
                            options: groups.map((group: any) => {
                                return { label: group.name, value: `group-${group.player_group_id}` }
                            })
                        }
                    ]}
                >
                </Select>
            </Col>

            <Col style={{ display: 'flex', flexDirection: 'column' }}>
                <Text>Only include</Text>

                <Select
                    mode="multiple"
                    onChange={(data) => setDays(data)}
                    defaultValue={days}
                    placeholder="All Days"
                    options={[
                        {
                            label: 'Game Days',
                            options: [
                                { label: 'GD', value: 'GD' },
                                { label: 'GD-1', value: 'GD-1' },
                                { label: 'GD-2', value: 'GD-2' },
                                { label: 'GD-3', value: 'GD-3' },
                                { label: 'GD-4', value: 'GD-4' },
                                { label: 'GD+1', value: 'GD+1' },
                            ]
                        },
                        {
                            label: 'Days',
                            options: [
                                { label: 'Mondays', value: 'Monday' },
                                { label: 'Tuesdays', value: 'Tuesday' },
                                { label: 'Wednesdays', value: 'Wednesday' },
                                { label: 'Thursdays', value: 'Thursday' },
                                { label: 'Fridays', value: 'Friday' },
                                { label: 'Saturdays', value: 'Saturday' },
                                { label: 'Sundays', value: 'Sunday' },
                            ]
                        },
                    ]}
                >
                </Select>
            </Col>
        </Col>
    )
}

interface IFirstStep {
    startDate: string
    setStartDate: React.Dispatch<string>
    endDate: string
    setEndDate: React.Dispatch<string>
    days: string[]
    setDays: React.Dispatch<string[]>
    players: string[]
    setPlayers: React.Dispatch<string[]>
    playerLabels: string[]
    setPlayerLabels: React.Dispatch<string[]>
}

export default FirstStep